import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { IconDefinition } from 'src/components/Icon';
import { PlatformTab } from 'src/models/platform/_types';
interface DecoratedNavItem extends PlatformTab {
  reactRoute?: string;
  icon?: IconDefinition;
  children?: DecoratedNavItem[];
  target?: string;
}

export const useAdminNav = (): DecoratedNavItem[] => {
  return [
    {
      id: 'platforms',
      name: 'Platforms',
      route: '',
      reactRoute: '/admin/platform',
      icon: icon({ name: 'building', style: 'regular' }),
      enabled: true,
    },
    {
      id: 'users',
      name: 'Users',
      route: '',
      reactRoute: '/admin/user',
      icon: icon({ name: 'users', style: 'regular' }),
      enabled: true,
    },
    {
      id: 'emails',
      name: 'Email Templates',
      icon: icon({ name: 'envelope', style: 'regular' }),
      route: '',
      reactRoute: '/admin/emails',
      enabled: true,
    },
    {
      id: 'email_history',
      name: 'Email History',
      route: '',
      reactRoute: '/admin/email_history',
      icon: icon({ name: 'envelope-open', style: 'regular' }),
      enabled: true,
    },
    {
      id: 'utilities',
      name: 'Utilities',
      route: '',
      reactRoute: '/admin/utilities/update_twilio_numbers',
      icon: icon({ name: 'wrench', style: 'regular' }),
      enabled: true,
      children: [
        {
          id: 'twilio',
          name: 'Twilio Admin',
          route: '',
          reactRoute: '/admin/utilities/update_twilio_numbers',
          enabled: true,
        },
        {
          id: 'hello-bar',
          name: 'Hello Bar',
          route: '',
          reactRoute: '/admin/utilities/hello-bar',
          enabled: true,
        },
      ],
    },
  ];
};
